<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <card v-else-if="!this.loading && !this.errormessage">
      <div
        class="row"
        no-gutters
        align-h="between"
      >
        <div class="col-lg-8 col-md-8">
          <fg-input>
            <label>Packing List Audience</label>
            <el-select
              class="select-default2"
              size="large"
              name="priorcritter"
              placeholder=""
              v-model="listindex"
            >
              <el-option
                v-for="option in selectorOptions"
                class="select-default2"
                :value="option.value"
                :label="option.text"
                :key="option.value"
              />
            </el-select>
          </fg-input>
        </div>
      </div>
      <div
        class="row"
        v-if="packinglist.Groups"
      >
        <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
          <tabs
            pills
            type="primary"
            icons
            centered
          >
            <tab-pane
              v-for="grp in packinglist.Groups"
              :key="grp.Id"
              :id="grp.Id.toString()"
            >
              <span slot="title"><i class="nc-icon nc-umbrella-13" /> {{ grp.Description }}</span>
              <div class="card-body row table-full-width">
                <el-table
                  class="table-striped"
                  header-row-class-name="text-primary"
                  :data="grp.PackingListItems"
                >
                  <el-table-column
                    prop="Description"
                    label="Item Name"
                  />
                  <el-table-column
                    class-name="action-buttons td-actions"
                    align="right"
                    width="100"
                    label="Actions"
                  >
                    <template slot-scope="props">
                      <p-button
                        type="info"
                        size="sm"
                        title="Edit"
                        icon
                        @click="updateItemDialog(props.row)"
                      >
                        <i class="fa fa-edit" />
                      </p-button>
                      <p-button
                        type="danger"
                        size="sm"
                        title="Delete"
                        icon
                        @click="deleteItemConfirm(props.row)"
                      >
                        <i class="fa fa-times" />
                      </p-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <button
                type="button"
                class="btn btn-success mr-5"
                @click="addItemDialog(grp.Id)"
              >
                Add Item
              </button>
              <button
                type="button"
                class="btn btn-info ml-5 mr-1"
                @click="updateGroupDialog(grp.Id, grp.Description)"
              >
                Edit Category Name
              </button>
              <button
                type="button"
                class="btn btn-danger"
                outline
                @click="deleteGroupConfirm(grp.Id)"
              >
                Remove Category
              </button>
            </tab-pane>
            <tab-pane
              id="addCat"
              key="addCat"
            >
              <span slot="title">
                <i class="nc-icon nc-simple-add" /> Add Category
              </span>
              <div class="row mt-5">
                <div class="col-lg-2 col-md-2" />
                <div class="col-lg-8 col-md-8">
                  <ValidationObserver ref="form">
                    <form @submit.prevent="validate">
                      <ValidationProvider
                        name="categoryName"
                        rules="required|max:255"
                        v-slot="{ passed, failed }"
                      >
                        <fg-input
                          name="categoryName"
                          :error="failed ? 'The Category Name is required': null"
                          :has-success="passed"
                          required
                          label="New Category Name"
                          placeholder=""
                          max-length="255"
                          v-model="updateCat.Name"
                        />
                      </ValidationProvider>
                      <div class="text-right">
                        <button
                          type="submit"
                          class="btn btn-success"
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </card>
  </div>
</template>

<script>

import packingListApi from '@/services/api/packinglist'
import oops from '@/components/_main/oops.vue'
import Tabs from '@/plugins/paper-components/tabs/tabs.vue'
import TabPane from '@/plugins/paper-components/tabs/tab.vue'

export default {
  name: 'PackingListEdit',
  components: {
    oops,
    Tabs,
    TabPane
  },
  data: function () {
    return {
      lists: null,
      listindex: 0,
      loading: true,
      errormessage: null,
      updateCat: {
        Name: null,
        GroupId: null
      },
      selectorOptions: [],
      tempHolding: null,
      tempHolding2: null
    }
  },
  computed: {
    packinglist: function () {
      return this.lists[this.listindex]
    }
  },
  mounted () {
    packingListApi.getMgmt(this.$root.courseKey)
      .then(response => {
        this.lists = response
        let i
        for (i = 0; i < response.length; i++) {
          const roleName = response[i].IsParticipantPackingList ? 'Participant' : 'Staff'
          const j = { value: i, text: roleName }
          this.selectorOptions.push(j)
        }
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    getGroup: function (groupId) {
      let returnValue = null
      for (let i = 0; i < this.packinglist.Groups.length; i++) {
        if (this.packinglist.Groups[i].Id === groupId) {
          returnValue = this.packinglist.Groups[i]
          break
        }
      }
      return returnValue
    },
    deleteItemConfirm: function (row) {
      this.tempHolding = row
      const msg = 'Are you sure you want to delete "' + row.Description + '" ?'
      this.$confirm(msg, 'Please Confirm', {
        buttonSize: 'sm',
        centered: true
      }).then(() => {
        this.deleteItem(row.PackingListGroupId, row.Id)
      })
    },
    deleteItem: function (groupId, id) {
      packingListApi.deleteItem(groupId, id)
        .then(x => {
          this.updateListItemsList(groupId, x)
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error deleting the packing list item.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
    },
    validateName: function (value) {
      if (value === null || value === undefined || value.length === 0) {
        return 'A value is required.'
      } else if (value.length > 255) {
        return 'The value has a max length of 255'
      } else {
        return true
      }
    },
    addItemDialog: function (groupId) {
      this.$prompt('Please enter the new value', 'Add Item', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputValidator: this.validateName
      }).then(({ value }) => {
        this.addItem(groupId, value)
      })
    },
    addItem: function (groupId, description) {
      packingListApi.addItem(groupId, description)
        .then(x => {
          this.updateListItemsList(groupId, x)
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error adding your item.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
    },
    updateItemDialog: function (row) {
      this.$prompt('Please enter the new value', 'Edit Item', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputValidator: this.validateName,
        inputValue: row.Description
      }).then(({ value }) => {
        row.Description = value
        this.updateItem(row)
      })
    },
    updateItem: function (item) {
      packingListApi.updateItem(item)
        .then(x => {
          this.updateListItemsList(item.PackingListGroupId, x)
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating your item.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
    },
    updateListItemsList: function (groupId, items) {
      const grp = this.getGroup(groupId)
      grp.PackingListItems = items
    },
    deleteGroupConfirm: function (groupId) {
      const grp = this.getGroup(groupId)
      const msg = 'Are you sure you want to delete "' + grp.Description + '" ?  This will delete all of the items associated with this category'
      this.$confirm(msg, 'Are you sure?', {
        buttonSize: 'sm',
        centered: true
      }).then(() => {
        this.deleteGroup(groupId)
      })
    },
    deleteGroup: function (groupId) {
      packingListApi.deleteCategory(this.packinglist.Id, groupId)
        .then(x => {
          this.lists[this.listindex].Groups = null
          this.$nextTick(function () {
            this.lists[this.listindex].Groups = x
          })
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error deleting your group.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
    },
    updateGroupDialog: function (groupId, groupName) {
      this.$prompt('Please enter the new Category', 'Edit Category', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputValidator: this.validateName,
        inputValue: groupName
      }).then(({ value }) => {
        this.updateCat.Name = value
        this.updateCat.GroupId = groupId
        this.updateGroup()
      })
    },
    validate: function () {
      return this.$refs.form.validate().then(res => {
        this.updateGroup()
        return res
      })
    },
    updateGroup: function () {
      let grp
      if (this.updateCat.GroupId === null) {
        grp = {
          CoursePackingListId: this.packinglist.Id,
          Description: this.updateCat.Name,
          Id: null,
          Order: null
        }
      } else {
        grp = this.getGroup(this.updateCat.GroupId)
        grp.Description = this.updateCat.Name
      }
      packingListApi.updateCategory(this.packinglist.Id, grp)
        .then(x => {
          this.lists[this.listindex].Groups = null
          this.$nextTick(function () {
            this.lists[this.listindex].Groups = x
          })
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating your group.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
    }
  }
}
</script>
